/**
 * CZNA-1513 — reads the records behind the register rows the user has expanded, from
 * GET /czna-authorities/records/index/{headingId}/records, one query per row.
 *
 * <p>`language` and `status` are the register's filters in force: a row's count was taken
 * under them, so its records must be too.
 */
import { useMemo, useRef } from 'react';
import { useQueries } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { fetchRecordIndexGroup } from '../api/recordService';
var INDEX_GROUP_KEY = 'czna-authorities-record-index-group';
var useRecordIndexGroups = function (headingIds, language, status) {
    // Unstable-`ky` trap: useOkapiKy() returns a fresh instance each render; key only on
    // serializable params and read ky from a ref (same as useIndexLanguages).
    var ky = useOkapiKy();
    var kyRef = useRef(ky);
    kyRef.current = ky;
    var results = useQueries(headingIds.map(function (headingId) { return ({
        queryKey: [INDEX_GROUP_KEY, headingId, language !== null && language !== void 0 ? language : null, status],
        queryFn: function () { return fetchRecordIndexGroup(kyRef.current, headingId, { language: language, status: status }); },
    }); }));
    // useQueries hands back a new array every render. The register's rows are built from
    // this map, and a new rows array makes the list re-compare its data, so the map changes
    // only when a query does.
    var resultsRef = useRef(results);
    resultsRef.current = results;
    var signature = headingIds
        .map(function (id, i) { var _a, _b; return "".concat(id, ":").concat((_a = results[i]) === null || _a === void 0 ? void 0 : _a.status, ":").concat((_b = results[i]) === null || _b === void 0 ? void 0 : _b.dataUpdatedAt); })
        .join('|');
    return useMemo(function () { return new Map(signature ? signature.split('|').map(function (part, i) {
        var _a, _b;
        var result = resultsRef.current[i];
        return [Number(part.split(':')[0]), {
                group: result === null || result === void 0 ? void 0 : result.data,
                isLoading: (_a = result === null || result === void 0 ? void 0 : result.isLoading) !== null && _a !== void 0 ? _a : true,
                isError: (_b = result === null || result === void 0 ? void 0 : result.isError) !== null && _b !== void 0 ? _b : false,
            }];
    }) : []); }, [signature]);
};
export default useRecordIndexGroups;
